// Setup.tsx — first-run superuser bootstrap wizard on react-bootstrap.
import { useState } from 'react'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Alert from 'react-bootstrap/Alert'
import { BsPlusLg } from 'react-icons/bs'
import Text from 'common/ui/Text'

const Setup = () => {
    const [email, setEmail] = useState('singhrohit.stargate@gmail.com')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [googleClientId, setGoogleClientId] = useState('')
    const [googleClientSecret, setGoogleClientSecret] = useState('')
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState('')

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setError('')
        if (password !== confirmPassword) {
            setError('Passwords do not match')
            return
        }
        if (password.length < 8) {
            setError('Password must be at least 8 characters')
            return
        }
        setSubmitting(true)
        try {
            const res = await fetch('/api/setup/bootstrap', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email,
                    password,
                    google_client_id: googleClientId,
                    google_client_secret: googleClientSecret,
                }),
                credentials: 'include',
            })
            const data = await res.json()
            if (!res.ok) {
                setError(data.error || 'Bootstrap failed')
                setSubmitting(false)
                return
            }
            localStorage.setItem('identity_token', data.token)
            window.location.assign('/dashboard')
        } catch (err: unknown) {
            setError(err instanceof Error ? err.message : 'Network error')
            setSubmitting(false)
        }
    }

    return (
        <div className="auth-wrapper">
            <Card style={{ width: '540px', maxWidth: '100%' }}>
                <Card.Body>
                    <h2 className="mb-1">OpenFactory AuthZ</h2>
                    <p className="text-muted mb-4">
                        Create a superuser account to get started. Optionally,
                        configure social logins for your domain.
                    </p>
                    {error && <Alert variant="danger">{error}</Alert>}

                    <Form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
                        <fieldset className="card p-3 d-flex flex-column gap-3">
                            <legend className="float-none w-auto px-2 small text-uppercase text-muted">
                                Superuser
                            </legend>
                            <Form.Group controlId="setup-email">
                                <Form.Label>Email</Form.Label>
                                <Text
                                    type="email"
                                    style={{ width: "100%" }}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    autoFocus
                                />
                            </Form.Group>
                            <Form.Group controlId="setup-password">
                                <Form.Label>Password</Form.Label>
                                <Text
                                    type="password"
                                    style={{ width: "100%" }}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    minLength={8}
                                />
                            </Form.Group>
                            <Form.Group controlId="setup-confirm">
                                <Form.Label>Confirm password</Form.Label>
                                <Text
                                    type="password"
                                    style={{ width: "100%" }}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                    minLength={8}
                                />
                            </Form.Group>
                        </fieldset>

                        <fieldset className="card p-3 d-flex flex-column gap-3">
                            <legend className="float-none w-auto px-2 small text-uppercase text-muted">
                                Google OAuth (optional)
                            </legend>
                            <p className="text-muted small mb-0">
                                Stored in the vault at{' '}
                                <code>authz://*/prod/social/google/credentials</code>.
                                Leave blank to configure later.
                            </p>
                            <Form.Group controlId="setup-google-id">
                                <Form.Label>Client ID</Form.Label>
                                <Text
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={googleClientId}
                                    onChange={(e) => setGoogleClientId(e.target.value)}
                                    placeholder="123-abc.apps.googleusercontent.com"
                                />
                            </Form.Group>
                            <Form.Group controlId="setup-google-secret">
                                <Form.Label>Client secret</Form.Label>
                                <Text
                                    type="password"
                                    style={{ width: "100%" }}
                                    value={googleClientSecret}
                                    onChange={(e) => setGoogleClientSecret(e.target.value)}
                                    placeholder="GOCSPX-…"
                                />
                            </Form.Group>
                        </fieldset>

                        <Button variant="success" type="submit" disabled={submitting} className="d-flex align-items-center justify-content-center gap-2">
                            <BsPlusLg /> {submitting ? 'Setting up…' : 'Create superuser'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    )
}

export default Setup
